<span fxHide fxShow.gt-xs class="display-name">{{
  identity.userDisplayName | async
}}</span>
<button
  color="accent"
  mat-icon-button
  [matMenuTriggerFor]="menu"
  aria-label="Example icon-button with a menu"
>
  <mat-icon id="menu-icon">account_circle</mat-icon>
</button>
<mat-menu #menu="matMenu">
  <button routerLink="/my-profile" mat-menu-item>
    {{ identity.userDisplayName | async }}
  </button>
  <button mat-menu-item (click)="identity.signOut()">
    <mat-icon>exit_to_app</mat-icon>
    Log Out
  </button>
</mat-menu>
